import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { format } from 'date-fns';



// date picker
const DatePicker = (props) => {

	const [month, setMonth] = useState();
	const [year, setYear] = useState();
	const [date, setDate] = useState(false);
  	useEffect(() => {
  		axios.get(`api/get_list_month`).then(res => {
  			console.log('status',res.data.open_month);
	        if (res.status === 200) {
	        	 var months = {
				    'January':'01',
				    'February':'02',
				    'March':'03',
				    'April':'04',
				    'May':'05',
				    'June':'06',
				    'July':'07',
				    'August':'08',
				    'September':'09',
				    'October':'10',
				    'November':'11',
				    'December':'12'
				  };
				 if(res.data.open_month==='not_open'){
				 	document.getElementById("date").disabled = true;
				 	document.getElementById('dataRemark').style.display = 'block';
		     //    	var month = new Date().getFullYear();
	  				// var month = new Date().getMonth() + 1;
	  				// // var day = new Date().getDate();
		       //  	setMonth(res.data.listmonth);
		       //    	setYear(res.data.year);
		     		// setDate(true);

				 }else{
					var openingMonth = res.data.listmonth.month_name;
		          	// console.log(months[openingMonth]);
		          	setMonth(months[openingMonth]);
		          	setYear(res.data.listmonth.year);
		          	// setDate(true);
				 }
	        }
			else{
				var year = new Date().getFullYear();
                var month = new Date().getMonth() + 1;
                var day = new Date().getDate();
				setMonth(month);
	          	setYear(year);
			}
      	});
  	},[]);

	var todate = format(new Date(), 'yyyy'+'-'+'MM'+'-'+'dd')

	if(month === "04" || month === "06" || month=== "09" || month==="11"){
		var minDate = year+"-"+ month +"-30";
		// var todate = yyyy + '-' + month + '-' + '30';
	}
	else if(month === "02"){
	    var minDate = year+"-"+ month +"-01";
	    // var todate = yyyy + '-' + month + '-' + '28';
	}
	else{
	    var minDate = year+"-"+ month +"-01";
	    // var todate = yyyy + '-' + month + '-' + '31';
	}
	// var minDate = "2023-01-01"
	// console.log(props)
	return(
		
		<input disabled={false} type="date" name="date" id="date" className="form-control" placeholder="Enter Date" min={minDate} max={todate}/>
		
	)
}


export default DatePicker